/*
 * @Author: huangzq
 * @Date: 2020-04-11 16:20:33
 * @Last Modified by: huangzq
 * @Last Modified time: 2020-04-15 22:21:27
 * @Desc: 表格标签展示组件-只能在表格中使用的
*/
<template>
  <tag-list-show :tag-list="scope.row.showTags"></tag-list-show>
</template>

<script>
import TagListShow from '@/components/tag-list-show-new/index.vue'
export default {
  name: 'ListTableColumnTag',
  components: {
    TagListShow
  },
  props: {
    scope: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
